(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["angebote-bundles"]) return;
  try {
    
  window.location.href = '/';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('hero-reviews-rating')) return;

    var ENDPOINT = 'https://api.reviews.io/timeline/data';

    class HeroReviewsRating extends HTMLElement {
      connectedCallback() {
        if (this.dataset.live !== 'true' || !this.dataset.store) return;
        // Skip the request when the banner is not rendered (e.g. desktop-only mode on a phone).
        if (!this.getClientRects().length) return;

        this.loadStats().then((stats) => {
          if (stats) this.render(stats);
        });
      }

      loadStats() {
        var cacheKey = 'hero-reviews-stats:' + this.dataset.store;

        try {
          var cached = JSON.parse(window.sessionStorage.getItem(cacheKey));
          if (cached && cached.rating && cached.count) return Promise.resolve(cached);
        } catch (e) {}

        var params = new URLSearchParams({
          per_page: '0',
          type: 'store_review',
          include_local_reviews: 'true',
          include_product_reviews: 'true',
          sort: 'date_desc',
          tag: '',
          lang: this.dataset.lang || 'de',
          store: this.dataset.store
        });

        return fetch(ENDPOINT + '?' + params.toString())
          .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
          .then((data) => {
            var stats = data && data.stats;
            var rating = Number(stats && stats.average_rating);
            var count = Number(stats && stats.review_count);
            if (!rating || !count) return null;

            var result = { rating: rating, count: count };
            try {
              window.sessionStorage.setItem(cacheKey, JSON.stringify(result));
            } catch (e) {}
            return result;
          })
          .catch(() => null);
      }

      render(stats) {
        var ratingEl = this.querySelector('[data-rating-value]');
        var countEl = this.querySelector('[data-review-count]');
        if (ratingEl) ratingEl.textContent = Number(stats.rating).toFixed(1);
        if (countEl) countEl.textContent = this.formatCount(stats.count);
      }

      formatCount(value) {
        var rounded = Math.round(value);
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'de-DE', { useGrouping: true }).format(rounded);
        } catch (e) {
          return String(rounded);
        }
      }
    }

    customElements.define('hero-reviews-rating', HeroReviewsRating);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-shop-cta-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyShopCta extends HTMLElement {
    connectedCallback() {
      this.triggerSelector = this.dataset.triggerSelector || '';
      this.headerSelector = this.dataset.headerSelector || 'header.header';
      this.trigger = this.resolveTrigger();

      this.onResize = this.onResize.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.hide();
      this.updateHeaderOffset();

      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('orientationchange', this.onResize, { passive: true });

      if (this.trigger && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.hide();
                return;
              }
              // Not intersecting: show only when the trigger sits above the
              // viewport (i.e. the visitor has scrolled past it).
              if (entry.boundingClientRect.top < 0) {
                this.show();
              } else {
                this.hide();
              }
            });
          },
          { rootMargin: '0px', threshold: 0 }
        );

        this.observer.observe(this.trigger);
      } else {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('orientationchange', this.onResize);
      window.removeEventListener('scroll', this.onScroll);
    }

    resolveTrigger() {
      let element = null;

      if (this.triggerSelector) {
        try {
          element = document.querySelector(this.triggerSelector);
        } catch (error) {
          element = null;
        }
      }

      // Fallback: use the section that immediately precedes this one
      // (i.e. the hero banner) as the scroll trigger.
      if (!element) {
        const wrapper = this.closest('.shopify-section');
        element = wrapper ? wrapper.previousElementSibling : null;
      }

      return element;
    }

    onResize() {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => this.updateHeaderOffset());
    }

    onScroll() {
      if (!this.trigger) return;
      const rect = this.trigger.getBoundingClientRect();
      if (rect.bottom <= 0) {
        this.show();
      } else {
        this.hide();
      }
    }

    updateHeaderOffset() {
      let header = null;
      try {
        header = document.querySelector(this.headerSelector);
      } catch (error) {
        header = null;
      }
      const height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      this.style.setProperty('--sticky-shop-cta-header-offset', height + 'px');
    }

    show() {
      this.classList.add('is-visible');
    }

    hide() {
      this.classList.remove('is-visible');
    }
  }

  if (!customElements.get('sticky-shop-cta')) {
    customElements.define('sticky-shop-cta', StickyShopCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor () {
      super()
      const poster = this.querySelector('[id^="Deferred-Poster-"]')
      if (!poster) return
      poster.addEventListener('click', this.loadContent.bind(this))
    }

    loadContent () {
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div')
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

        this.setAttribute('loaded', true)
        this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
      }
    }
  }
  if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', DeferredMedia)
  }

  } catch(e) { console.error(e); }
})();
})();
